import { Laugh, Users, Brain, Building2, MessageSquare, Star } from "lucide-react";

const benefits = [
  { title: "Integracja zespołu", description: "Wspólny śmiech zbliża ludzi i buduje silniejsze relacje w zespole", icon: Users },
  { title: "Redukcja stresu", description: "Humor to najlepszy sposób na rozładowanie napięcia w pracy", icon: Brain },
  { title: "Pozytywny wizerunek", description: "Pokazujesz, że Twoja firma dba o dobrą atmosferę", icon: Building2 },
  { title: "Wzrost produktywności", description: "Zrelaksowani pracownicy są bardziej efektywni i kreatywni", icon: Star },
  { title: "Lepsza komunikacja", description: "Humor pomaga przełamać bariery i ułatwia komunikację", icon: MessageSquare },
  { title: "Niezapomniane wspomnienia", description: "Tworzymy momenty, które pozostaną w pamięci na długo", icon: Laugh },
];

export const Benefits = () => {
  return (
    <section id="benefits" className="py-24 section-dark relative overflow-hidden">
      <div className="absolute inset-0 mesh-gradient opacity-40" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-space-grotesk font-bold text-center mb-4 text-foreground">
          Dlaczego <span className="text-gradient">warto?</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Korzyści z profesjonalnego występu
        </p>
        <div className="grid md:grid-cols-3 gap-4">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div 
                key={benefit.title} 
                className="glass rounded-2xl p-6 hover:bg-white/[0.08] hover:border-primary/20 transition-all duration-300 hover:-translate-y-1 group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                  <Icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-lg font-space-grotesk font-bold mb-2 text-foreground">{benefit.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
